import styled from "styled-components"
import { InfoIcon } from "../../icons"
import { Tooltip } from "../../Tooltip"
import { Typography } from "../../typography"

const Container = styled.div<{ disabled?: boolean }>`
  width: inherit;
  border-radius: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.grey.$200};
  box-shadow: ${({ theme }) => theme.shadows.light};
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1rem;
  flex: 1 0 0;
  background-color: ${({ theme, disabled }) => (disabled ? theme.colors.grey.$100 : theme.colors.white)};
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;

  & > *:first-child {
    margin-right: 0.2rem;
  }

  svg {
    color: ${({ theme }) => theme.colors.grey.$500};
  }
`

const Content = styled.div`
  & > *:first-child {
    margin-bottom: 0.25rem;
  }
`

type MetricItemProps = {
  title: string
  value: string
  text: string | JSX.Element
  state: "default"
  disabled?: boolean
  tooltipInfo?: string
  tooltipPosition?: "top-left" | "top-right" | "bottom-left" | "bottom-right"
}

export const DeprecatedMetricItem: React.FC<MetricItemProps> = ({
  title,
  value,
  text,
  disabled,
  tooltipInfo,
  tooltipPosition = "bottom-left",
}) => {
  return (
    <Container disabled={disabled}>
      <TitleContainer>
        <Typography $variant="caption-2" $color={disabled ? "grey.$400" : "grey.$500"}>
          {title}
        </Typography>
        {tooltipInfo && (
          <Tooltip id="tooltip" content={tooltipInfo} position={tooltipPosition}>
            <InfoIcon size={18} />
          </Tooltip>
        )}
      </TitleContainer>
      <Content>
        <Typography $variant="body-2-semibold" $color={disabled ? "grey.$400" : "secondary.$200"}>
          {value}
        </Typography>
        <Typography $variant="caption-2" $color={disabled ? "grey.$400" : "grey.$500"}>
          {text}
        </Typography>
      </Content>
    </Container>
  )
}
